import Details from '@admin/components/details'
import Panel from '@admin/components/panel'
import PropTypes from 'prop-types'
import Publish from '../publish'
// import Edit from '../edit'
import React from 'react'

const Overview = ({ announcement }) => {

  const details = {
    audits: `truevail_announcements/${announcement.id}`,
    comments: `truevail_announcements/${announcement.id}`,
    sections: [
      {
        title: 't(Announcement Details)',
        items: [
          { label: 't(Title)', content: announcement.title },
          { 
            label: 't(Publish At)', 
            content: announcement.publish_at, 
            show: announcement.status === 'scheduled',
            format: 'datetime' 
          },
          { 
            label: 't(Published At)', 
            content: announcement.published_at, 
            show: announcement.status === 'published',
            format: 'datetime' 
          }
        ]
      }
    ]
  }

  if(announcement.deleted_at !== null) {
    details.alert = { color: 'red', message: 't(This announcement was deleted)' }
  } else if(announcement.status === 'draft') {
    details.alert = { color: 'grey', message: 't(This announcement is in draft mode)' }
  } else if(announcement.status === 'scheduled') {
    details.alert = { color: 'teal', message: 't(This announcement is scheduled)' }
  } else if(announcement.status === 'published') {
    details.alert = { color: 'green', message: 't(This announcement is published)' }
  }

  return <Details { ...details } />

}

Overview.propTypes = {
  announcement: PropTypes.object
}

const mapPropsToPanel = (props, context) => ({
  title: 't(Overview)',
  panel: <Overview announcement={ props.announcement } />,
  tasks: {
    items: [
      // {
      //   label: 't(Edit Announcement)',
      //   svg: 'square_pen',
      //   modal: <Edit announcement={ props.announcement } />
      // },
      {
        label: 't(Publish Announcement)',
        svg: 'check',
        show: props.announcement.status !== 'published',
        modal: <Publish announcement={ props.announcement } />
      },
      {
        label: 't(Unpublish Announcement)',
        svg: 'x',
        show: props.announcement.status === 'published',
        request: {
          endpoint: `/api/admin/truevail/admin/announcements/${props.announcement.id}/publish`,
          method: 'PATCH',
          body: {
            strategy: 'unpublish'
          },
          onSuccess: () => context.flash.set('success', 't(Successfully unpublished this announcement)'),
          onFailure: () => context.flash.set('error', 't(Unable to unpublish this announcement)')
        }
      },
      {
        label: 't(Delete Announcement)',
        svg: 'trash',
        confirm: 't(Are you sure you want to delete this announcement?)',
        deletable: true,
        request: {
          endpoint: `/api/admin/truevail/admin/announcements/${props.announcement.id}`,
          method: 'DELETE',
          onSuccess: () => {
            context.flash.set('success', 't(Successfully deleted announcement)')
            context.router.goBack()
          },
          onFailure: () => context.flash.set('error', 't(Unable to delete announcement)')
        }
      }
    ]
  }
})

export default Panel(null, mapPropsToPanel)
